<template>
  <div>
    <div class="card-9-53 mx-9 my-7">
      <!-- Header Section -->
      <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0">
        <div>
          <h2 class="text-xl roboto-regular text-gray-800">Manajemen Pengumuman</h2>
        </div>
        <div class="flex items-center space-x-2">
          <el-dropdown @command="handleSyncCommand" :hide-on-click="false">
            <el-button 
              type="success" 
              size="small" 
              :loading="syncLoading"
              class="roboto-regular">
              <i class="el-icon-refresh"></i>
              {{ syncLoading ? 'Syncing...' : 'Sync' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="latest">
                <i class="el-icon-download"></i>
                Sync 10 Berita Terbaru
              </el-dropdown-item>
              <el-dropdown-item command="all" divided>
                <i class="el-icon-refresh-left"></i>
                Sync Semua Data (Admin)
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            size="small" 
            @click="showCreateDialog = true"
            class="roboto-regular">
            Tambah Pengumuman
          </el-button>
        </div>
      </div>

      <!-- Search Section -->
      <div class="flex justify-start items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0">
        <div class="w-64">
          <el-input 
            class="roboto-mono-200" 
            placeholder="Cari pengumuman..." 
            size="mini" 
            v-model="searchText"
            clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="ml-3">
          <el-select 
            v-model="filterKategori" 
            placeholder="Semua Kategori" 
            size="mini" 
            clearable
            class="roboto-mono-200">
            <el-option label="Pengumuman" value="PENGUMUMAN"></el-option>
            <el-option label="Pamflet" value="PAMFLET"></el-option>
            <el-option label="Berita" value="BERITA"></el-option>
          </el-select>
        </div>
        <div class="ml-3">
          <el-select 
            v-model="filterAktif" 
            placeholder="Semua Status" 
            size="mini" 
            clearable
            class="roboto-mono-200">
            <el-option label="Aktif" value="true"></el-option>
            <el-option label="Tidak Aktif" value="false"></el-option>
          </el-select>
        </div>
        <div class="flex-grow">
          <div class="flex items-center justify-end space-x-4">
            <!-- Last sync info -->
            <div v-if="lastSyncTime" class="text-xs text-gray-500">
              Terakhir sync: {{ lastSyncTime | formatDateTime }}
            </div>
            <p class="text-sm roboto-mono-300 p-0 m-0">
              {{ totalElements || 0 }} 
              <span class="roboto-light">Pengumuman</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Error Display -->
      <div v-if="get_pengumuman_error" class="mx-5 my-3">
        <el-alert
          :title="get_pengumuman_error"
          type="error"
          show-icon
          :closable="false">
        </el-alert>
      </div>

      <!-- Loading State -->
      <div v-if="get_pengumuman_loading" class="loading-container">
        <div class="loader"></div>
      </div>

      <!-- Data Table -->
      <div v-if="!get_pengumuman_loading">
        <el-table 
          :data="get_pengumuman" 
          style="width: 100%"
          class="roboto-regular"
          :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266' }">
          
          <el-table-column label="Gambar" width="100" align="center">
            <template slot-scope="scope">
              <img 
                v-if="scope.row.imagePath || scope.row.imageUrl" 
                :src="getImageUrl(scope.row)" 
                alt="Gambar Pengumuman" 
                class="w-16 h-12 object-cover rounded cursor-pointer"
                @error="handleTableImageError"
                @click="previewImage(scope.row)">
              <div v-else class="w-16 h-12 bg-gray-200 rounded flex items-center justify-center">
                <i class="el-icon-picture text-gray-400"></i>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="judul" label="Judul" min-width="200">
            <template slot-scope="scope">
              <div class="roboto-regular">{{ scope.row.judul }}</div>
              <div class="text-xs text-gray-500 roboto-light mt-1">
                {{ scope.row.isi | truncate(50) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="kategori" label="Kategori" width="120" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getKategoriType(scope.row.kategori)" 
                size="small">
                {{ getKategoriLabel(scope.row.kategori) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Awal Tayang" width="130" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET'" class="roboto-mono-300 text-sm">
                {{ scope.row.tanggal_terbit | formatDate }}
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

                    <el-table-column label="Link" width="100" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET' && scope.row.link">
                <el-button 
                  type="text" 
                  icon="el-icon-link" 
                  size="mini" 
                  @click="openLink(scope.row.link)"
                  title="Buka Link">
                  Link
                </el-button>
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Akhir Tayang" width="130" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET'" class="roboto-mono-300 text-sm">
                {{ scope.row.tanggal_selesai | formatDate }}
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Publish" width="120" align="center">
            <template slot-scope="scope">
              <div class="roboto-mono-300 text-sm">
                {{ scope.row.publishedDate | formatDate }}
              </div>
            </template>
          </el-table-column>


          <el-table-column label="Status" width="80" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="scope.row.aktif ? 'success' : 'danger'" 
                size="mini">
                {{ scope.row.aktif ? 'Aktif' : 'Non-Aktif' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Posisi" width="90" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getPosisiType(scope.row.posisi)" 
                size="mini">
                {{ getPosisiLabel(scope.row.posisi) }}
              </el-tag>
            </template>
          </el-table-column>


          <el-table-column label="Aksi" width="200" align="center">
            <template slot-scope="scope">
              <el-button 
                v-if="scope.row.filePath && scope.row.kategori === 'PENGUMUMAN'"
                type="info" 
                icon="el-icon-download" 
                size="mini" 
                circle 
                @click="downloadAttachment(scope.row)"
                title="Download File">
              </el-button>
              <el-button 
                type="primary" 
                icon="el-icon-edit" 
                size="mini" 
                circle 
                @click="editPengumuman(scope.row)"
                title="Edit">
              </el-button>
              <el-button 
                :type="scope.row.aktif ? 'warning' : 'success'"
                :icon="scope.row.aktif ? 'el-icon-close' : 'el-icon-check'" 
                size="mini" 
                circle 
                @click="toggleStatus(scope.row)"
                :title="scope.row.aktif ? 'Nonaktifkan' : 'Aktifkan'">
              </el-button>
              <el-button 
                type="danger" 
                icon="el-icon-delete" 
                size="mini" 
                circle 
                @click="confirmDelete(scope.row)"
                title="Hapus">
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- Pagination -->
        <div class="flex justify-center mt-4 mb-4">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="get_pagination.currentPage + 1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="get_pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="get_pagination.totalElements">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- Create/Edit Dialog -->
    <el-dialog 
      :title="isEdit ? 'Edit Pengumuman' : 'Tambah Pengumuman'"
      :visible.sync="showCreateDialog"
      width="1200px"
      :close-on-click-modal="false">
      
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="pengumumanForm" 
        label-width="120px"
        class="roboto-regular">
        
        <!-- Kategori Section (Paling Atas) -->
        <div class="form-row">
          <el-form-item label="Kategori" prop="kategori" class="form-full-width">
            <el-select v-model="form.kategori" placeholder="Pilih kategori" style="width: 100%">
              <el-option label="Pamflet" value="PAMFLET"></el-option>
              <el-option label="Pengumuman" value="PENGUMUMAN"></el-option>
              <el-option label="Berita" value="BERITA"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- Top Section: Judul (Full Width) - Show for all categories -->
        <div class="form-row">
          <el-form-item label="Judul" prop="judul" class="form-full-width">
            <el-input v-model="form.judul" placeholder="Masukkan judul pengumuman"></el-input>
          </el-form-item>
        </div>

        <!-- Main Section: VueEditor (Full Width) - Hide for PAMFLET -->
        <div class="form-row" v-if="form.kategori != 'PAMFLET'">
          <el-form-item label="Isi" prop="isi" class="form-full-width">
            <vue-editor 
              v-model="form.isi"
              :editor-toolbar="customToolbar"
              placeholder="Masukkan isi pengumuman">
            </vue-editor>
          </el-form-item>
        </div>

        <!-- Grid Section: Left Column -->
        <div class="form-grid">
          <div class="form-column">
            <!-- Topic Name Field - Hide for PAMFLET -->
            <el-form-item label="Topic" prop="topicName" v-if="form.kategori !== 'PAMFLET'">
              <el-select v-model="form.topicName" placeholder="Pilih topic" style="width: 100%" clearable filterable>
                <el-option 
                  v-for="topic in getAllTopics" 
                  :key="topic.id" 
                  :label="topic.displayName || topic.topicName" 
                  :value="topic.topicName">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- Hide for PENGUMUMAN and BERITA -->
            <el-form-item label="Tanggal Terbit" prop="tanggal_terbit" v-if="form.kategori === 'PAMFLET'">
              <el-date-picker
                v-model="form.tanggal_terbit"
                type="date"
                placeholder="Pilih tanggal terbit"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- Hide for PENGUMUMAN and BERITA -->
            <el-form-item label="Tanggal Selesai" prop="tanggal_selesai" v-if="form.kategori === 'PAMFLET'">
              <el-date-picker
                v-model="form.tanggal_selesai"
                type="date"
                placeholder="Pilih tanggal selesai"
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- Hide for PENGUMUMAN and BERITA -->
            <el-form-item label="Posisi" prop="posisi" v-if="form.kategori === 'PAMFLET'">
              <el-select v-model="form.posisi" placeholder="Pilih posisi" style="width: 100%">
                <el-option label="Depan" value="DEPAN"></el-option>
                <el-option label="Tengah" value="TENGAH"></el-option>
                <el-option label="Belakang" value="BELAKANG"></el-option>
              </el-select>
              <div class="text-xs text-gray-500 mt-1">
                Posisi tampilan pengumuman di halaman
              </div>
            </el-form-item>
          </div>

          <!-- Grid Section: Right Column -->
          <div class="form-column">
            <!-- Hide for PENGUMUMAN and BERITA -->
            <el-form-item label="Pop Up" v-if="form.kategori === 'PAMFLET'">
              <el-switch
                v-model="form.is_popup"
                active-text="Ya"
                inactive-text="Tidak">
              </el-switch>
              <div class="text-xs text-gray-500 mt-1">
                Mengatur apakah pengumuman ditampilkan sebagai popup (pamflet)
              </div>
            </el-form-item>

            <!-- Hide for PENGUMUMAN and BERITA -->
            <el-form-item label="Status" v-if="form.kategori === 'PAMFLET'">
              <el-switch
                v-model="form.aktif"
                active-text="Aktif"
                inactive-text="Tidak Aktif">
              </el-switch>
            </el-form-item>

            <el-form-item label="Link" v-if="form.kategori === 'PAMFLET'">
              <el-input 
                v-model="form.link" 
                placeholder="Masukkan link eksternal untuk pamflet (opsional)"
                :disabled="form.kategori !== 'PAMFLET'">
              </el-input>
              <div class="text-xs text-gray-500 mt-1">
                Link eksternal yang akan dibuka ketika pamflet diklik
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- Gambar Section (Full Width) - Show for all categories -->
        <div class="form-row mt-4" v-if="form.kategori !== ''">
          <el-form-item label="Gambar" class="form-full-width">
            <!-- Image Mode Toggle -->
            <div class="mb-3">
              <el-radio-group v-model="imageMode" size="small">
                <el-radio-button label="upload">Upload File</el-radio-button>
                <el-radio-button label="url">URL Gambar</el-radio-button>
              </el-radio-group>
            </div>

            <!-- URL Input Mode -->
            <div v-if="imageMode === 'url'">
              <el-input
                v-model="form.gambar_url"
                placeholder="Masukkan URL gambar (contoh: https://example.com/image.jpg atau link Google Drive)"
                @blur="validateImageUrl">
                <template slot="prepend">
                  <i class="el-icon-link"></i>
                </template>
              </el-input>
              <div class="text-xs text-gray-500 mt-1">
                Pastikan URL gambar dapat diakses secara publik. Untuk Google Drive, gunakan format: https://drive.google.com/uc?id=FILE_ID
              </div>
              <!-- URL Preview -->
              <div v-if="form.gambar_url && isValidUrl(form.gambar_url)" class="mt-2">
                <div class="text-xs text-gray-600 mb-1">Preview:</div>
                <img 
                  :src="form.gambar_url" 
                  alt="Preview"
                  class="w-32 h-24 object-cover border rounded"
                  @error="handleImageError"
                  @load="handleImageLoad">
              </div>
            </div>

            <!-- File Upload Mode -->
            <div v-if="imageMode === 'upload'">
              <!-- Show existing image info when editing -->
              <div v-if="isEdit && form.existing_image_url && fileList.length > 0" class="mb-2">
                <el-alert
                  title="Gambar Existing"
                  type="info"
                  :closable="false"
                  show-icon>
                  <div slot="title">
                    <span class="text-sm">Gambar saat ini akan diganti jika Anda upload file baru</span>
                  </div>
                </el-alert>
              </div>
              
              <el-upload
                ref="upload"
                :auto-upload="false"
                :on-change="handleFileChange"
                :on-remove="handleFileRemove"
                :before-upload="beforeUpload"
                :file-list="fileList"
                accept="image/*"
                list-type="picture-card"
                :limit="1">
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="el-upload__tip" slot="tip">
                File gambar dengan ukuran maksimal 2MB (JPG, PNG, GIF)
              </div>
              <!-- Show current uploaded file preview if exists -->
              <div v-if="uploadedImagePreview && !fileList.length" class="mt-2">
                <div class="text-xs text-gray-600 mb-1">File yang akan diupload:</div>
                <img 
                  :src="uploadedImagePreview" 
                  alt="Upload Preview"
                  class="w-32 h-24 object-cover border rounded">
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- File Attachment Section (Full Width) - Only for PENGUMUMAN -->
        <div class="form-row mt-4" v-if="form.kategori === 'PENGUMUMAN'">
          <el-form-item label="File Lampiran" class="form-full-width">
            <el-upload
              ref="attachmentUpload"
              :auto-upload="false"
              :on-change="handleAttachmentChange"
              :on-remove="handleAttachmentRemove"
              :before-upload="beforeAttachmentUpload"
              :file-list="attachmentFileList"
              :limit="1">
              <el-button size="small" type="primary">Pilih File</el-button>
              <div slot="tip" class="el-upload__tip">
                File attachment untuk pengumuman (PDF, DOC, XLS, dsb - max 10MB)
              </div>
            </el-upload>
            <div v-if="form.fileName" class="mt-2">
              <el-tag type="success" closable @close="removeExistingAttachment">
                <i class="el-icon-document"></i> {{ form.fileName }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm" class="roboto-regular">Batal</el-button>
        <el-button 
          type="primary" 
          @click="submitForm" 
          :loading="get_pengumuman_loading"
          class="roboto-regular">
          {{ isEdit ? 'Update' : 'Simpan' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { mapGetters } from 'vuex';

export default {
  components: { 
    VueEditor 
  },
  props: {
    'deviceType': String
  },
  data() {
    return {
      API_BASE_URL: process.env.VUE_APP_API_HOST+'/api' || 'https://apidev-intranet.lan.go.id'+'/api',
      searchText: '',
      filterKategori: '',
      filterAktif: '',
      currentPage: 1,
      pageSize: 10,
      showCreateDialog: false,
      isEdit: false,
      editId: null,
      fileList: [],
      attachmentFileList: [], // For file attachment (PENGUMUMAN only)
      imageMode: 'upload', // 'upload' or 'url'
      uploadedImagePreview: null, // For showing file upload preview
      uploadedAttachmentFile: null, // For storing attachment file
      syncLoading: false, // For sync button loading state
      lastSyncTime: null, // Last sync timestamp
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image'],
        ['clean']
      ],
      form: {
        judul: '',
        isi: '',
        kategori: '',
        tanggal_terbit: '',
        tanggal_selesai: '',
        is_popup: false,
        link: '',
        gambar: null,
        gambar_url: '',
        attachmentFile: null, // For file attachment (PENGUMUMAN)
        filePath: '', // MinIO file path
        fileName: '', // Original file name
        posisi: 'TENGAH',
        aktif: true,
        topicName: ''
      },
      rules: {
        judul: [
          { 
            required: true, 
            message: 'Judul harus diisi', 
            trigger: 'blur'
          }
        ],
        isi: [
          { 
            required: true, 
            message: 'Isi pengumuman harus diisi', 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // Skip validation for PAMFLET
              if (this.form.kategori === 'PAMFLET') {
                callback()
              } else if (!value) {
                callback(new Error('Isi pengumuman harus diisi'))
              } else {
                callback()
              }
            }
          }
        ],
        kategori: [
          { required: true, message: 'Kategori harus dipilih', trigger: 'change' }
        ],
        tanggal_terbit: [
          { required: true, message: 'Tanggal terbit harus diisi', trigger: 'change' }
        ],
        tanggal_selesai: [
          { required: true, message: 'Tanggal selesai harus diisi', trigger: 'change' }
        ],
        posisi: [
          { required: true, message: 'Posisi harus dipilih', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
    truncate: function(text, length) {
      if (!text) return ''
      if (text.length <= length) return text
      return text.substring(0, length) + '...'
    },
    formatDate: function(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('id-ID')
    },
    formatDateTime: function(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('id-ID') + ' ' + d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
    }
  },
  computed: {
    get_pengumuman() {
      return this.$store.state.pengumuman.pengumuman
    },
    get_pengumuman_loading() {
      return this.$store.state.pengumuman.loading
    },
    get_pengumuman_error() {
      return this.$store.state.pengumuman.error
    },
    get_pagination() {
      return this.$store.state.pengumuman.pagination
    },
    ...mapGetters('topic', ['getAllTopics']),
    // Remove client-side filtering as we now use server-side
    totalElements() {
      return this.get_pagination.totalElements || 0
    },
    // Show PAMFLET-specific columns only if there are PAMFLET items or PAMFLET filter is active
    showPamfletColumns() {
      // Always show if PAMFLET filter is active
      if (this.filterKategori === 'PAMFLET') {
        return true
      }
      
      // Show if there are PAMFLET items in current data
      return this.get_pengumuman.some(item => item.kategori === 'PAMFLET')
    }
  },
  watch: {
    // Auto set popup when kategori is PAMFLET
    'form.kategori': function(newVal) {
      if (newVal === 'PAMFLET') {
        this.form.is_popup = true
      } else if (newVal === 'BERITA' || newVal === 'PENGUMUMAN') {
        this.form.is_popup = false
        // Clear link field when not PAMFLET
        this.form.link = ''
      }
    },
    // Watch for search text changes
    searchText: {
      handler() {
        this.currentPage = 1
        this.debouncedSearch()
      }
    },
    // Watch for filter changes
    filterKategori() {
      this.currentPage = 1
      this.loadPengumuman()
    },
    filterAktif() {
      this.currentPage = 1
      this.loadPengumuman()
    },
    // Watch for image mode changes to clear opposite field
    imageMode(newMode) {
      if (newMode === 'url') {
        this.form.gambar = null
        this.fileList = []
        this.uploadedImagePreview = null
      } else {
        this.form.gambar_url = ''
      }
    }
  },
  created() {
    this.loadPengumuman()
    // Load topics for dropdown
    this.$store.dispatch('topic/getAllTopics').catch(error => {
      console.error('Failed to load topics:', error)
    })
    // Create debounced search function
    this.debouncedSearch = this.debounce(() => {
      this.loadPengumuman()
    }, 500)
  },
  methods: {
    async loadPengumuman() {
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.pageSize,
          search: this.searchText || '',
          kategori: this.filterKategori || '',
          aktif: this.filterAktif || ''
        }
        await this.$store.dispatch('pengumuman/getPengumuman', params)
      } catch (error) {
        this.$message.error('Gagal memuat data pengumuman')
      }
    },
    getPosisiType(posisi) {
      switch (posisi) {
        case 'DEPAN': return 'success'
        case 'TENGAH': return 'warning'
        case 'BELAKANG': return 'info'
        default: return 'info'
      }
    },
    getPosisiLabel(posisi) {
      switch (posisi) {
        case 'DEPAN': return 'Depan'
        case 'TENGAH': return 'Tengah'
        case 'BELAKANG': return 'Belakang'
        default: return '-'
      }
    },
    getKategoriType(kategori) {
      switch (kategori) {
        case 'PAMFLET': return 'danger'
        case 'PENGUMUMAN': return 'warning'
        case 'BERITA': return 'success'
        default: return 'info'
      }
    },
    getKategoriLabel(kategori) {
      switch (kategori) {
        case 'PAMFLET': return 'Pamflet'
        case 'PENGUMUMAN': return 'Pengumuman'
        case 'BERITA': return 'Berita'
        default: return kategori
      }
    },
    openLink(link) {
      if (link) {
        window.open(link, '_blank')
      }
    },
    handleSyncCommand(command) {
      if (command === 'latest') {
        this.syncInformasi('latest')
      } else if (command === 'all') {
        this.syncInformasi('all')
      }
    },
    async syncInformasi(type = 'latest') {
      try {
        this.syncLoading = true
        let result
        
        if (type === 'all') {
          // Admin sync - full sync
          result = await this.$store.dispatch('pengumuman/syncInformasi', { type: 'all' })
        } else {
          // Default - latest news sync
          result = await this.$store.dispatch('pengumuman/syncInformasi', { type: 'latest' })
        }
        
        // Show detailed sync result
        if (result.success !== false) {
          const syncedCount = result.syncedCount || result.newItems || 0
          const skippedCount = result.skippedCount || result.existingItems || 0
          let message = `Sinkronisasi berhasil! `
          
          if (syncedCount > 0) {
            message += `${syncedCount} data baru disinkronkan. `
          }
          if (skippedCount > 0) {
            message += `${skippedCount} data sudah ada (dilewati).`
          }
          if (syncedCount === 0 && skippedCount === 0) {
            message += `Tidak ada data baru untuk disinkronkan.`
          }
          
          this.$message.success(message)
          this.lastSyncTime = new Date()
        } else {
          this.$message.warning(result.message || 'Sinkronisasi selesai dengan peringatan')
        }
        
        // Reload data after sync
        await this.loadPengumuman()
      } catch (error) {
        console.error('Sync error:', error)
        const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Gagal melakukan sinkronisasi data'
        this.$message.error(errorMessage)
      } finally {
        this.syncLoading = false
      }
    },
    async toggleStatus(pengumuman) {
      try {
        // Call API to toggle status
        await this.$store.dispatch('pengumuman/toggleStatus', pengumuman.id)
        this.$message.success(`Status pengumuman berhasil ${pengumuman.aktif ? 'dinonaktifkan' : 'diaktifkan'}`)
        // Reload data
        await this.loadPengumuman()
      } catch (error) {
        this.$message.error('Gagal mengubah status pengumuman')
      }
    },
    editPengumuman(pengumuman) {
      this.isEdit = true
      this.editId = pengumuman.id
      
      this.form = {
        judul: pengumuman.judul,
        isi: pengumuman.isi,
        kategori: pengumuman.kategori,
        tanggal_terbit: pengumuman.tanggal_terbit,
        tanggal_selesai: pengumuman.tanggal_selesai,
        is_popup: pengumuman.is_popup,
        link: pengumuman.link || '',
        gambar: null,
        gambar_url: '',
        filePath: pengumuman.filePath || '',
        fileName: pengumuman.fileName || '',
        attachmentFile: null,
        posisi: pengumuman.posisi || 'TENGAH',
        aktif: pengumuman.aktif,
        existing_image_url: pengumuman.imagePath || pengumuman.imageUrl, // Priority: imagePath first
        topicName: pengumuman.topicName || ''
      }
      
      // Reset preview
      this.uploadedImagePreview = null
      
      // Set existing image if available (prioritize imagePath over imageUrl)
      const existingImage = pengumuman.imagePath || pengumuman.imageUrl
      
      if (existingImage) {
        // Check if we have imagePath (MinIO) - prioritize this
        if (pengumuman.imagePath && pengumuman.imagePath.trim() !== '') {
          // For MinIO images (imagePath field exists), show in fileList with proxy URL
          this.imageMode = 'upload'
          this.fileList = [{
            name: 'Current Image',
            url: this.getImageUrl(pengumuman),
            uid: Date.now(),
            status: 'success'
          }]
        } else if (this.isValidUrl(existingImage)) {
          // Fallback to URL mode if it's a valid external URL
          this.imageMode = 'url'
          this.form.gambar_url = existingImage
          this.fileList = []
        } else {
          // For legacy file-based images
          this.imageMode = 'upload'
          this.fileList = [{
            name: 'Current Image',
            url: this.getImageUrl(pengumuman),
            uid: Date.now(),
            status: 'success'
          }]
        }
      } else {
        this.imageMode = 'upload'
        this.fileList = []
      }
      
      this.showCreateDialog = true
    },
    confirmDelete(pengumuman) {
      this.$confirm(`Apakah Anda yakin ingin menghapus pengumuman "${pengumuman.judul}"?`, 'Konfirmasi Hapus', {
        confirmButtonText: 'Ya, Hapus',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$store.dispatch('pengumuman/deletePengumuman', pengumuman.id)
          this.$message.success('Pengumuman berhasil dihapus')
        } catch (error) {
          this.$message.error('Gagal menghapus pengumuman')
        }
      }).catch(() => {
        // User cancelled
      })
    },
    handleFileChange(file, fileList) {
      this.form.gambar = file.raw
      
      // Create preview URL for the uploaded file
      if (file.raw) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.uploadedImagePreview = e.target.result
        }
        reader.readAsDataURL(file.raw)
        
        // Show success message for file selection
        this.$message.success('File gambar berhasil dipilih')
        
        // If editing and there's an existing image, show replacement message
        if (this.isEdit && this.form.existing_image_url) {
          this.$message.info('Gambar existing akan diganti dengan file baru ini')
        }
      }
      
      // Update fileList to show the upload
      this.fileList = fileList
    },
    handleFileRemove(file, fileList) {
      this.form.gambar = null
      this.uploadedImagePreview = null
      this.fileList = fileList
    },
    beforeUpload(file) {
      // Validate file type
      const isImage = file.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.error('File harus berupa gambar!')
        return false
      }
      
      // Validate file size (2MB)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Ukuran file tidak boleh lebih dari 2MB!')
        return false
      }
      
      return false // Prevent automatic upload
    },
    // Attachment file handlers (for PENGUMUMAN)
    handleAttachmentChange(file, fileList) {
      this.uploadedAttachmentFile = file.raw
      this.attachmentFileList = fileList
      this.$message.success('File lampiran berhasil dipilih')
    },
    handleAttachmentRemove(file, fileList) {
      this.uploadedAttachmentFile = null
      this.attachmentFileList = fileList
      this.$message.info('File lampiran dihapus')
    },
    beforeAttachmentUpload(file) {
      // Validate file size (10MB for attachments)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('Ukuran file tidak boleh lebih dari 10MB!')
        return false
      }
      return false // Prevent automatic upload
    },
    removeExistingAttachment() {
      this.form.filePath = ''
      this.form.fileName = ''
      this.$message.success('File lampiran existing dihapus')
    },
    // Download attachment file from MinIO
    downloadAttachment(pengumuman) {
      if (!pengumuman.id || !pengumuman.filePath) {
        this.$message.warning('File tidak tersedia')
        return
      }
      
      // Use proxy endpoint to download file
      const downloadUrl = `${this.API_BASE_URL}/informasi/files/download/${pengumuman.id}`
      window.open(downloadUrl, '_blank')
      this.$message.success(`Mengunduh file: ${pengumuman.fileName || 'attachment'}`)
    },
    // Image URL validation methods
    isValidUrl(string) {
      try {
        const url = new URL(string)
        return url.protocol === 'http:' || url.protocol === 'https:'
      } catch (_) {
        return false
      }
    },
    validateImageUrl() {
      if (this.form.gambar_url && !this.isValidUrl(this.form.gambar_url)) {
        this.$message.warning('Format URL tidak valid')
      }
    },
    handleImageError() {
      this.$message.error('Gambar tidak dapat dimuat. Periksa URL gambar.')
    },
    handleImageLoad() {
      this.$message.success('Preview gambar berhasil dimuat')
    },
    // Image URL helper methods
    getImageUrl(imageSource) {
      if (!imageSource) return null
      
      // If imageSource is an object (row from table)
      if (typeof imageSource === 'object' && imageSource.id) {
        
        // PRIORITY 1: Use imagePath from MinIO if available (NEW PRIORITY)
        if (imageSource.imagePath && imageSource.imagePath.trim() !== '') {
          return `${this.API_BASE_URL}/informasi/images/view/${imageSource.id}`
        }
        
        // PRIORITY 2: Use imageUrl if imagePath is not available (FALLBACK)
        if (imageSource.imageUrl && imageSource.imageUrl.trim() !== '') {
          // If imageUrl is a complete URL, return as is
          if (this.isValidUrl(imageSource.imageUrl)) {
            return imageSource.imageUrl
          }
          // If it's a relative path, construct the full URL
          return `${this.API_BASE_URL}${imageSource.imageUrl}`
        }
        
        return null
      }
      
      // If imageSource is a string (legacy code path)
      const imageUrl = imageSource
      
      // If it's already a complete URL (http/https), return as is
      if (this.isValidUrl(imageUrl)) {
        return imageUrl
      }
      
      // If it's a filename from upload, construct the API URL
      if (imageUrl && !imageUrl.startsWith('http')) {
        return `${this.API_BASE_URL}${imageUrl}`
      }
      
      return imageUrl
    },
    isImageUrl(url) {
      if (!url) return false
      return this.isValidUrl(url) || url.indexOf('/') !== -1
    },
    handleTableImageError(event) {
      // Replace broken image with placeholder
      event.target.style.display = 'none'
      const placeholder = event.target.parentNode.querySelector('.bg-gray-200')
      if (placeholder) {
        placeholder.style.display = 'flex'
      }
    },
    previewImage(imageSource) {
      if (!imageSource) return
      
      const fullImageUrl = this.getImageUrl(imageSource)
      if (fullImageUrl) {
        // Open image in a new tab for preview
        window.open(fullImageUrl, '_blank')
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadPengumuman()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadPengumuman()
    },
    resetForm() {
      this.showCreateDialog = false
      this.isEdit = false
      this.editId = null
      this.imageMode = 'upload'
      this.uploadedImagePreview = null
      this.uploadedAttachmentFile = null
      this.attachmentFileList = []
      this.form = {
        judul: '',
        isi: '',
        kategori: '',
        tanggal_terbit: '',
        tanggal_selesai: '',
        is_popup: false,
        link: '',
        gambar: null,
        gambar_url: '',
        attachmentFile: null,
        filePath: '',
        fileName: '',
        posisi: 'TENGAH',
        aktif: true,
        topicName: ''
      }
      this.fileList = []
      this.attachmentFileList = []
      if (this.$refs.pengumumanForm) {
        this.$refs.pengumumanForm.resetFields()
      }
    },
    submitForm() {
      this.$refs.pengumumanForm.validate(async (valid) => {
        if (valid) {
          try {
            // Prepare form data based on image mode
            const formData = { ...this.form }
            
            // For PAMFLET, set default value for isi if empty
            if (formData.kategori === 'PAMFLET') {
              if (!formData.isi) {
                formData.isi = 'Pamflet'
              }
            }
            
            // Save existing image URL before deleting
            const existingImageUrl = formData.existing_image_url
            delete formData.existing_image_url
            
            // Handle image upload to MinIO
            if (this.imageMode === 'upload' && this.form.gambar) {
              const imageFormData = new FormData()
              imageFormData.append('file', this.form.gambar)
              
              const imageResponse = await this.$store.dispatch('pengumuman/uploadImageToMinio', imageFormData)
              
              if (imageResponse && imageResponse.data && imageResponse.data.imagePath) {
                // Upload to MinIO: use imagePath and set imageUrl with informasi ID
                formData.imagePath = imageResponse.data.imagePath
                
                // Set imageUrl directly with the appropriate ID
                if (this.isEdit) {
                  formData.imageUrl = `${this.API_BASE_URL}/informasi/images/view/${this.editId}`
                } else {
                  formData.imageUrl = 'PLACEHOLDER_FOR_UPDATE' // Will be updated after creation
                }
                
              }
              delete formData.gambar
            } else if (this.imageMode === 'url') {
              // Use external URL: use imageUrl (PRIORITY)
              if (this.form.gambar_url) {
                formData.imageUrl = this.form.gambar_url
                formData.imagePath = null // Clear imagePath when using external URL
              } else if (this.isEdit && existingImageUrl) {
                // Keep existing URL
                if (this.isValidUrl(existingImageUrl)) {
                  formData.imageUrl = existingImageUrl
                  formData.imagePath = null
                } else {
                  formData.imagePath = existingImageUrl
                  // Generate imageUrl for existing MinIO image
                  if (this.editId) {
                    formData.imageUrl = `${this.API_BASE_URL}/informasi/images/view/${this.editId}`
                  } else {
                    formData.imageUrl = null
                  }
                }
              }
            } else if (this.isEdit && existingImageUrl) {
              // Keep existing image if no new file
              if (this.isValidUrl(existingImageUrl)) {
                formData.imageUrl = existingImageUrl
                formData.imagePath = null
              } else {
                formData.imagePath = existingImageUrl
                // Generate imageUrl for existing MinIO image
                if (this.editId) {
                  formData.imageUrl = `${this.API_BASE_URL}/informasi/images/view/${this.editId}`
                } else {
                  formData.imageUrl = null
                }
              }
            }
            
            // Clean up gambar and gambar_url fields
            delete formData.gambar
            delete formData.gambar_url
            
            // Handle attachment file upload to MinIO (for PENGUMUMAN only)
            if (formData.kategori === 'PENGUMUMAN' && this.uploadedAttachmentFile) {
              const attachmentFormData = new FormData()
              attachmentFormData.append('file', this.uploadedAttachmentFile)
              
              const fileResponse = await this.$store.dispatch('pengumuman/uploadFileToMinio', attachmentFormData)
              
              if (fileResponse && fileResponse.data) {
                formData.filePath = fileResponse.data.filePath
                formData.fileName = fileResponse.data.fileName
              }
            }
            
            // Clean up attachmentFile field
            delete formData.attachmentFile

            let result
            if (this.isEdit) {
              result = await this.$store.dispatch('pengumuman/updatePengumuman', {
                id: this.editId,
                pengumumanData: formData
              })
              
              this.$message.success('Pengumuman berhasil diupdate')
            } else {
              result = await this.$store.dispatch('pengumuman/createPengumuman', formData)
              
              // Update imageUrl after successful creation if we have imagePath but placeholder imageUrl
              // Use the ID of the newly created informasi for the proxy URL
              if (formData.imagePath && formData.imageUrl === 'PLACEHOLDER_FOR_UPDATE' && result && result.id) {
                const updateData = {
                  imageUrl: `${this.API_BASE_URL}/informasi/images/view/${result.id}`
                }
                await this.$store.dispatch('pengumuman/updatePengumuman', {
                  id: result.id,
                  pengumumanData: updateData
                })
              }
              
              this.$message.success('Pengumuman berhasil dibuat')
            }
            this.resetForm()
          } catch (error) {
            console.error('Submit error:', error)
            this.$message.error(this.isEdit ? 'Gagal mengupdate pengumuman' : 'Gagal membuat pengumuman')
          }
        }
      })
    },
    // Debounce function to limit API calls during search
    debounce(func, delay) {
      let timeoutId
      return function (...args) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => func.apply(this, args), delay)
      }
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* VueEditor styles */
::v-deep .vue-editor {
  min-height: 300px;
}

::v-deep .ql-container {
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  min-height: 250px;
  border: 1px solid #DCDFE6;
  border-top: none;
  border-radius: 0 0 4px 4px;
}

::v-deep .ql-editor {
  padding: 12px 15px;
  line-height: 1.6;
}

::v-deep .ql-toolbar {
  border: 1px solid #DCDFE6;
  border-radius: 4px 4px 0 0;
  background-color: #f5f7fa;
}

::v-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}

::v-deep .ql-snow a {
  color: #409EFF;
}

::v-deep .ql-editor.ql-blank::before {
  color: #909399;
  font-style: normal;
}

/* Dialog Grid Layout Styles */
::v-deep .form-row {
  display: flex;
  width: 100%;
}

::v-deep .form-full-width {
  width: 100% !important;
}

::v-deep .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
}

::v-deep .form-column {
  display: flex;
  flex-direction: column;
  gap: 0;
}

::v-deep .form-column .el-form-item {
  margin-bottom: 22px;
}

::v-deep .mt-4 {
  margin-top: 24px;
}

.card-9-53 {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
